import { render, staticRenderFns } from "./refundDialog.vue?vue&type=template&id=3917bd2c&scoped=true"
import script from "./refundDialog.vue?vue&type=script&lang=js"
export * from "./refundDialog.vue?vue&type=script&lang=js"
import style0 from "./refundDialog.vue?vue&type=style&index=0&id=3917bd2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3917bd2c",
  null
  
)

export default component.exports